"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalExpress = void 0;
exports.TotalExpress = {
    id: 'totalExpress',
    companyName: 'Total Express',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'totalExpress',
    },
    isInternal: false,
    isActive: true,
    countries: ['CA'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG90YWxFeHByZXNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL1RvdGFsRXhwcmVzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLFlBQVksR0FBVTtJQUMvQixFQUFFLEVBQUUsY0FBYztJQUNsQixXQUFXLEVBQUUsZUFBZTtJQUM1QixjQUFjLEVBQUUsQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDO0lBQzlCLFdBQVcsRUFBRTtRQUNULFdBQVcsRUFBRSxJQUFJO1FBQ2pCLEtBQUssRUFBRSxjQUFjO0tBQ3hCO0lBQ0QsVUFBVSxFQUFFLEtBQUs7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxTQUFTLEVBQUUsQ0FBQyxJQUFJLENBQUM7Q0FDcEIsQ0FBQSJ9